export default __webpack_public_path__ + "470bb4ee57fc51e2636775242cfb8db2.png";